<template>
<div class="container fluid" >
<div class="row" v-if="isLoaded && user.authenticated">
<div class="col-md-12">
<p><strong>Send to:</strong><br>{{wireInfo.fullAddress}}</p>
<p><strong>Wires:</strong> ABA/ROUTING {{wireInfo.wireRoute}}</p>
<p><strong>ACH:</strong> ABA/ROUTING {{wireInfo.achRoute}}</p>
<p><strong>Swift Code:</strong> {{wireInfo.swiftCode}}</p>
<p><strong>For Further Credit:</strong> Pawnee Leasing Corporation  (Account # {{wireInfo.pawneeAcctNumber}})</p>
<p><strong>RE:</strong> Your name and Contract #</p>
<p><strong>Special Instructions:</strong> {{wireInfo.specialInstructions}}</p>
<p>**  Please make sure you call us after you have sent a wire or ACH transfer, so we can contact our bank to apply your funds.</p>
<p>Any other questions , please call us at {{wireInfo.phoneNumber}}</p>
</div>
</div>
<div class="row" v-else>
  <div class="col text-center">
  <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalWireInstructions',
  components: {
  },
  props: {
    parentData: {
      type: Number
    }
  },
  methods: {
    openPaymentInNewTab: function (url) {
      window.open(url, '_blank')
    }
  },
  data: function () {
    return {
      wireInfo: {},
      user: auth.user,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  mounted: function () {
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/wires', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.wireInfo = response.data
        console.log(this.wireInfo)
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('wireInfo') &&
      this.wireInfo != null) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modalWireInstructions.vue